import React from 'react'
import styles from './UserImage.module.scss'
export function UserImage(props: {first_name: string; last_name: string}) {
  const chars = `${props.first_name?.split?.('')?.[0] ?? ''}${props.last_name?.split?.('')?.[0] ?? ''}`.toUpperCase()
  return (
    <div className={styles.container}>
        {chars}
    </div>
  )
}
